<section class="cr-hilfe-wahl">
  <div class="cr-hilfe-wahl__inner">
    <header class="cr-hilfe-wahl__head">
      <span class="cr-hilfe-wahl__eyebrow">Hilfe-Center</span>
      <h1 class="cr-hilfe-wahl__title">Wie können wir helfen?</h1>
      <p class="cr-hilfe-wahl__lead">
        Such dir aus, ob du Hilfe als Kunde oder als Handwerker suchst.
        Beides geht — auch wenn du eingeloggt bist.
      </p>
    </header>

    @if (user$ | async; as user) {
      @if (preferredRoute(user.rolle); as preferred) {
        <div class="cr-hilfe-wahl__hint">
          <span class="cr-hilfe-wahl__hint-icon" aria-hidden="true">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none"
                 stroke="currentColor" stroke-width="2" stroke-linecap="round"
                 stroke-linejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="16" x2="12" y2="12"/>
              <line x1="12" y1="8" x2="12.01" y2="8"/>
            </svg>
          </span>
          <span class="cr-hilfe-wahl__hint-text">
            Du bist als <strong>{{ user.rolle }}</strong> eingeloggt.
            <a [routerLink]="preferred">Direkt zur passenden Hilfe →</a>
          </span>
        </div>
      }
    }

    <div class="cr-hilfe-wahl__grid">
      <a routerLink="/hilfe/kunden" class="cr-hilfe-wahl__card">
        <div class="cr-hilfe-wahl__card-icon" aria-hidden="true">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
               stroke-linejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 01-2 2h-4v-7H9v7H5a2 2 0 01-2-2z"/>
          </svg>
        </div>
        <h2 class="cr-hilfe-wahl__card-title">Ich bin Kunde</h2>
        <p class="cr-hilfe-wahl__card-desc">
          Anfrage stellen, Angebote vergleichen, Termin buchen, bezahlen.
          50 häufige Fragen rund um deine Buchung.
        </p>
        <span class="cr-hilfe-wahl__card-cta">
          Zur Kunden-Hilfe
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round"
               stroke-linejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"/>
            <polyline points="12 5 19 12 12 19"/>
          </svg>
        </span>
      </a>

      <a routerLink="/hilfe/handwerker" class="cr-hilfe-wahl__card">
        <div class="cr-hilfe-wahl__card-icon" aria-hidden="true">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="1.6" stroke-linecap="round"
               stroke-linejoin="round">
            <path d="M14.7 6.3a1 1 0 000 1.4l1.6 1.6a1 1 0 001.4 0l3.77-3.77a6 6 0 01-7.94 7.94l-6.91 6.91a2.12 2.12 0 01-3-3l6.91-6.91a6 6 0 017.94-7.94l-3.76 3.76z"/>
          </svg>
        </div>
        <h2 class="cr-hilfe-wahl__card-title">Ich bin Handwerker</h2>
        <p class="cr-hilfe-wahl__card-desc">
          Onboarding, Angebote abgeben, Aufträge ausführen, Provision &
          Auszahlung, DAC7. 56 Fragen rund um deinen Betrieb.
        </p>
        <span class="cr-hilfe-wahl__card-cta">
          Zur Handwerker-Hilfe
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none"
               stroke="currentColor" stroke-width="2" stroke-linecap="round"
               stroke-linejoin="round">
            <line x1="5" y1="12" x2="19" y2="12"/>
            <polyline points="12 5 19 12 12 19"/>
          </svg>
        </span>
      </a>
    </div>

    <p class="cr-hilfe-wahl__footer">
      Nicht gefunden, was du suchst?
      <a routerLink="/hilfe/kunden" fragment="kontakt">Schreib uns</a>.
    </p>
  </div>
</section>
